"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//@ts-ignore
const logo_svg_1 = __importDefault(require("../../assest/icon/logo.svg"));
//@ts-ignore
const logo_white_svg_1 = __importDefault(require("../../assest/icon/logo_white.svg"));
//@ts-ignore
const out_svg_1 = __importDefault(require("../../assest/icon/out.svg"));
//@ts-ignore
const answer_count_svg_1 = __importDefault(require("../../assest/icon/answer-count.svg"));
//@ts-ignore
const total_count_svg_1 = __importDefault(require("../../assest/icon/total-count.svg"));
//@ts-ignore
const Q_svg_1 = __importDefault(require("../../assest/icon/Q.svg"));
//@ts-ignore
const A_svg_1 = __importDefault(require("../../assest/icon/A.svg"));
//@ts-ignore
const ic_minus_ring_svg_1 = __importDefault(require("../../assest/icon/ic-minus-ring.svg"));
//@ts-ignore
const ic_pdf_svg_1 = __importDefault(require("../../assest/icon/ic-pdf.svg"));
//@ts-ignore
const ic_zip_svg_1 = __importDefault(require("../../assest/icon/ic-zip.svg"));
//@ts-ignore
const ic_pause_svg_1 = __importDefault(require("../../assest/icon/ic_pause.svg"));
//@ts-ignore
const ic_play_svg_1 = __importDefault(require("../../assest/icon/ic_play.svg"));
//@ts-ignore
const ic_soundoff_svg_1 = __importDefault(require("../../assest/icon/ic_soundoff.svg"));
//@ts-ignore
const ic_soundon_svg_1 = __importDefault(require("../../assest/icon/ic_soundon.svg"));
// @ts-ignore
const ic_attend_title_svg_1 = __importDefault(require("../../assest/icon/ic-attend-title.svg"));
// @ts-ignore
const ic_task_title_svg_1 = __importDefault(require("../../assest/icon/ic-task-title.svg"));
// @ts-ignore
const ic_test_title_svg_1 = __importDefault(require("../../assest/icon/ic-test-title.svg"));
//@ts-ignore
const profile_pic_svg_1 = __importDefault(require("../../assest/icon/profile-pic.svg"));
//@ts-ignore
const teacher_svg_1 = __importDefault(require("../../assest/icon/teacher.svg"));
//@ts-ignore
const ic_2arrow_svg_1 = __importDefault(require("../../assest/icon/ic-2arrow.svg"));
//@ts-ignore
const ic_arrow_svg_1 = __importDefault(require("../../assest/icon/ic-arrow.svg"));
//@ts-ignore
const ic_full_arrow_svg_1 = __importDefault(require("../../assest/icon/ic-full-arrow.svg"));
//@ts-ignore
const ic_search_svg_1 = __importDefault(require("../../assest/icon/ic-search.svg"));
//@ts-ignore
const ic_checked_svg_1 = __importDefault(require("../../assest/icon/ic-checked.svg"));
//@ts-ignore
const ic_unchecked_svg_1 = __importDefault(require("../../assest/icon/ic-unchecked.svg"));
//@ts-ignore
const ic_file_svg_1 = __importDefault(require("../../assest/icon/ic-file.svg"));
//@ts-ignore
const ic_cancel_svg_1 = __importDefault(require("../../assest/icon/ic-cancel.svg"));
//@ts-ignore
const ic_close_svg_1 = __importDefault(require("../../assest/icon/ic-close.svg"));
// @ts-ignore
const ic_none_svg_1 = __importDefault(require("../../assest/icon/ic-none.svg"));
//@ts-ignore
const ic_message_svg_1 = __importDefault(require("../../assest/icon/ic-message.svg"));
//@ts-ignore
const ic_pen_edit_svg_1 = __importDefault(require("../../assest/icon/ic-pen-edit.svg"));
//@ts-ignore
const ic_add_survey_svg_1 = __importDefault(require("../../assest/icon/ic-add-survey.svg"));
//@ts-ignore
const ic_del_survey_svg_1 = __importDefault(require("../../assest/icon/ic-del-survey.svg"));
// @ts-ignore
const ic_radio_checked_svg_1 = __importDefault(require("../../assest/icon/ic-radio-checked.svg"));
// @ts-ignore
const ic_radio_unchecked_svg_1 = __importDefault(require("../../assest/icon/ic-radio-unchecked.svg"));
// @ts-ignore
const ic_edit_svg_1 = __importDefault(require("../../assest/icon/ic-edit.svg"));
// @ts-ignore
const ic_delete_svg_1 = __importDefault(require("../../assest/icon/ic-delete.svg"));
// @ts-ignore
const ic_settings_svg_1 = __importDefault(require("../../assest/icon/ic-settings.svg"));
// @ts-ignore
const ic_save_svg_1 = __importDefault(require("../../assest/icon/ic-save.svg"));
// @ts-ignore
const ic_assignment_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-assignment-on.svg"));
// @ts-ignore
const ic_assignment_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-assignment-off.svg"));
// @ts-ignore
const ic_test_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-test-on.svg"));
// @ts-ignore
const ic_test_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-test-off.svg"));
// @ts-ignore
const ic_reservation_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-reservation-on.svg"));
// @ts-ignore
const ic_reservation_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-reservation-off.svg"));
// @ts-ignore
const ic_previous_conference_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-previous-conference-on.svg"));
// @ts-ignore
const ic_previous_conference_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-previous-conference-off.svg"));
const NoticeOn_1 = __importDefault(require("../../assest/icon/mobile-menu/NoticeOn"));
const NoticeOff_1 = __importDefault(require("../../assest/icon/mobile-menu/NoticeOff"));
// @ts-ignore
const ic_qna_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-qna-on.svg"));
// @ts-ignore
const ic_qna_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-qna-off.svg"));
// @ts-ignore
const ic_resource_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-resource-on.svg"));
// @ts-ignore
const ic_resource_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-resource-off.svg"));
// @ts-ignore
const ic_content_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-content-on.svg"));
// @ts-ignore
const ic_content_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-content-off.svg"));
// @ts-ignore
const ic_replay_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-replay-on.svg"));
// @ts-ignore
const ic_replay_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-replay-off.svg"));
// @ts-ignore
const ic_attendanceStatus_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-attendanceStatus-on.svg"));
// @ts-ignore
const ic_attendanceStatus_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-attendanceStatus-off.svg"));
// @ts-ignore
const ic_sendSMS_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-sendSMS-on.svg"));
// @ts-ignore
const ic_sendSMS_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-sendSMS-off.svg"));
// @ts-ignore
const ic_grade_on_svg_1 = __importDefault(require("../../assest/icon/menu/ic-grade-on.svg"));
// @ts-ignore
const ic_grade_off_svg_1 = __importDefault(require("../../assest/icon/menu/ic-grade-off.svg"));
// @ts-ignore
const ic_pass_svg_1 = __importDefault(require("../../assest/icon/ic-pass.svg"));
// @ts-ignore
const ic_union_svg_1 = __importDefault(require("../../assest/icon/ic-union.svg"));
//@ts-ignore
const ic_detail_delete_svg_1 = __importDefault(require("../../assest/icon/ic-detail-delete.svg"));
//@ts-ignore
const ic_check_in_circle_svg_1 = __importDefault(require("../../assest/icon/ic-check-in-circle.svg"));
//@ts-ignore
const ic_check_in_equal_svg_1 = __importDefault(require("../../assest/icon/ic-check-in-equal.svg"));
//@ts-ignore
const ic_file_down_svg_1 = __importDefault(require("../../assest/icon/ic-file-down.svg"));
//@ts-ignore
const ic_download_svg_1 = __importDefault(require("../../assest/icon/ic-download.svg"));
//@ts-ignore
const ic_add_folder_svg_1 = __importDefault(require("../../assest/icon/ic-add-folder.svg"));
//@ts-ignore
const ic_add_ring_svg_1 = __importDefault(require("../../assest/icon/ic-add-ring.svg"));
//@ts-ignore
const ic_locked_svg_1 = __importDefault(require("../../assest/icon/ic-locked.svg"));
//@ts-ignore
const ic_document_svg_1 = __importDefault(require("../../assest/icon/ic-document.svg"));
//@ts-ignore
const ic_video_svg_1 = __importDefault(require("../../assest/icon/ic-video.svg"));
//@ts-ignore
const ic_background_svg_1 = __importDefault(require("../../assest/icon/ic-background.svg"));
//@ts-ignore
const ic_plus_svg_1 = __importDefault(require("../../assest/icon/ic-plus.svg"));
//@ts-ignore
const ic_view_eye_svg_1 = __importDefault(require("../../assest/icon/ic-view-eye.svg"));
//@ts-ignore
const ic_home_on_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-home-on.svg"));
//@ts-ignore
const ic_home_off_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-home-off.svg"));
//@ts-ignore
const ic_live_on_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-live-on.svg"));
//@ts-ignore
const ic_live_off_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-live-off.svg"));
const LogoutOn_1 = __importDefault(require("../../assest/icon/mobile-menu/LogoutOn"));
const LogoutOff_1 = __importDefault(require("../../assest/icon/mobile-menu/LogoutOff"));
//@ts-ignore
const ic_management_on_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-management-on.svg"));
//@ts-ignore
const ic_management_off_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-management-off.svg"));
//@ts-ignore
const ic_myclass_on_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-myclass-on.svg"));
//@ts-ignore
const ic_myclass_off_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-myclass-off.svg"));
//@ts-ignore
const ic_support_on_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-support-on.svg"));
//@ts-ignore
const ic_support_off_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-support-off.svg"));
//@ts-ignore
const ic_menu_open_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-menu-open.svg"));
//@ts-ignore
const ic_menu_close_svg_1 = __importDefault(require("../../assest/icon/mobile-menu/ic-menu-close.svg"));
//@ts-ignore
const ic_question_svg_1 = __importDefault(require("../../assest/icon/ic-question.svg"));
//@ts-ignore
const ic_answer_svg_1 = __importDefault(require("../../assest/icon/ic-answer.svg"));
//@ts-ignore
const ic_page_off_svg_1 = __importDefault(require("../../assest/icon/ic-page-off.svg"));
//@ts-ignore
const ic_page_on_svg_1 = __importDefault(require("../../assest/icon/ic-page-on.svg"));
//@ts-ignore
const ic_cancel_mobile_svg_1 = __importDefault(require("../../assest/icon/ic-cancel-mobile.svg"));
//@ts-ignore
const ic_no_image_svg_1 = __importDefault(require("../../assest/icon/ic-no-image.svg"));
//@ts-ignore
const ic_delete_users_svg_1 = __importDefault(require("../../assest/icon/ic-delete-users.svg"));
//@ts-ignore
const ic_add_users_svg_1 = __importDefault(require("../../assest/icon/ic-add-users.svg"));
//@ts-ignore
const ic_delete_in_circle_svg_1 = __importDefault(require("../../assest/icon/ic-delete-in-circle.svg"));
//@ts-ignore
const ic_plus_in_circle_svg_1 = __importDefault(require("../../assest/icon/ic-plus-in-circle.svg"));
//@ts-ignore
const ic_dash_svg_1 = __importDefault(require("../../assest/icon/ic-dash.svg"));
//@ts-ignore
const ic_file_upload_svg_1 = __importDefault(require("../../assest/icon/ic-file-upload.svg"));
//@ts-ignore
const fullscreen_off_svg_1 = __importDefault(require("../../assest/icon/fullscreen_off.svg"));
//@ts-ignore
const fullscreen_on_svg_1 = __importDefault(require("../../assest/icon/fullscreen_on.svg"));
//@ts-ignore
const ic_arrow_in_circle_left_svg_1 = __importDefault(require("../../assest/icon/ic-arrow-in-circle-left.svg"));
//@ts-ignore
const ic_arrow_in_circle_right_svg_1 = __importDefault(require("../../assest/icon/ic-arrow-in-circle-right.svg"));
// @ts-ignore
const ic_user_svg_1 = __importDefault(require("../../assest/icon/ic-user.svg"));
const Icon = react_1.default.memo(({ className, style, icon, size = 20, width = size, height = size, stroke, fill, }) => {
    switch (icon) {
        case 'out':
            return react_1.default.createElement(out_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'answerCount':
            return react_1.default.createElement(answer_count_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'totalCount':
            return react_1.default.createElement(total_count_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'question-icon':
            return react_1.default.createElement(Q_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'answer-icon':
            return react_1.default.createElement(A_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'none':
            return react_1.default.createElement(ic_none_svg_1.default, { className: className, width: width, height: height, fill: fill });
        case 'attend-title':
            return react_1.default.createElement(ic_attend_title_svg_1.default, { className: className, width: width, height: height });
        case 'task-title':
            return react_1.default.createElement(ic_task_title_svg_1.default, { className: className, width: width, height: height });
        case 'test-title':
            return react_1.default.createElement(ic_test_title_svg_1.default, { className: className, width: width, height: height });
        case 'logo':
            return react_1.default.createElement(logo_svg_1.default, { className: className, width: width, height: height });
        case 'logo_white':
            return react_1.default.createElement(logo_white_svg_1.default, { className: className, width: width, height: height });
        case 'profile':
            return react_1.default.createElement(profile_pic_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'teacher':
            return react_1.default.createElement(teacher_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'twoarrow':
            return (react_1.default.createElement(ic_2arrow_svg_1.default, { className: className, style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'arrow':
            return (react_1.default.createElement(ic_arrow_svg_1.default, { className: className, style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'fullArrow':
            return (react_1.default.createElement(ic_full_arrow_svg_1.default, { className: className, style: style, width: width, height: height, stroke: stroke }));
        case 'vodStart':
            return react_1.default.createElement(ic_play_svg_1.default, { width: size, height: size, stroke: stroke, fill: fill });
        case 'vodPause':
            return react_1.default.createElement(ic_pause_svg_1.default, { width: size, height: size, stroke: stroke, fill: fill });
        case 'vodVolumeOn':
            return react_1.default.createElement(ic_soundon_svg_1.default, { width: size, height: size, stroke: stroke, fill: fill });
        case 'vodVolumeOff':
            return react_1.default.createElement(ic_soundoff_svg_1.default, { width: size, height: size, stroke: stroke, fill: fill });
        case 'search':
            return react_1.default.createElement(ic_search_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'checked':
            return react_1.default.createElement(ic_checked_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'unchecked':
            return react_1.default.createElement(ic_unchecked_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'file':
            return react_1.default.createElement(ic_file_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'cancel':
            return react_1.default.createElement(ic_cancel_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'close':
            return (react_1.default.createElement(ic_close_svg_1.default, { className: className, width: width, height: height, stroke: stroke, fill: fill }));
        case 'message':
            return react_1.default.createElement(ic_message_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'penEdit':
            return react_1.default.createElement(ic_pen_edit_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'add-survey':
            return react_1.default.createElement(ic_add_survey_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'del-survey':
            return react_1.default.createElement(ic_del_survey_svg_1.default, { width: width, height: height, stroke: stroke });
        case 'radio_checked':
            return react_1.default.createElement(ic_radio_checked_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'radio_unchecked':
            return react_1.default.createElement(ic_radio_unchecked_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'edit':
            return react_1.default.createElement(ic_edit_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'delete':
            return react_1.default.createElement(ic_delete_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'settings':
            return react_1.default.createElement(ic_settings_svg_1.default, { width: width, height: height });
        case 'save':
            return react_1.default.createElement(ic_save_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'assignment_on':
            return react_1.default.createElement(ic_assignment_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'assignment_off':
            return react_1.default.createElement(ic_assignment_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'test_on':
            return react_1.default.createElement(ic_test_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'test_off':
            return react_1.default.createElement(ic_test_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'attendanceStatus_on':
            return (react_1.default.createElement(ic_attendanceStatus_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill }));
        case 'attendanceStatus_off':
            return (react_1.default.createElement(ic_attendanceStatus_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill }));
        case 'reservation_on':
            return react_1.default.createElement(ic_reservation_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'reservation_off':
            return react_1.default.createElement(ic_reservation_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'previous-conference_on':
            return (react_1.default.createElement(ic_previous_conference_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill }));
        case 'previous-conference_off':
            return (react_1.default.createElement(ic_previous_conference_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill }));
        case 'replay_on':
            return react_1.default.createElement(ic_replay_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'replay_off':
            return react_1.default.createElement(ic_replay_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'gradeCard_on':
            return react_1.default.createElement(ic_grade_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'gradeCard_off':
            return react_1.default.createElement(ic_grade_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'sendSMS_on':
            return react_1.default.createElement(ic_sendSMS_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'sendSMS_off':
            return react_1.default.createElement(ic_sendSMS_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'notice_on':
            return react_1.default.createElement(NoticeOn_1.default, { width: width, height: height, fill: fill });
        case 'notice_off':
            return react_1.default.createElement(NoticeOff_1.default, { width: width, height: height, fill: fill });
        case 'qna_on':
            return react_1.default.createElement(ic_qna_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'qna_off':
            return react_1.default.createElement(ic_qna_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'survey_on':
            return react_1.default.createElement(ic_qna_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'survey_off':
            return react_1.default.createElement(ic_qna_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'resource_on':
            return react_1.default.createElement(ic_resource_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'resource_off':
            return react_1.default.createElement(ic_resource_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'content_on':
            return react_1.default.createElement(ic_content_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'content_off':
            return react_1.default.createElement(ic_content_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'pass':
            return react_1.default.createElement(ic_pass_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'fail':
            return react_1.default.createElement(ic_union_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'detail-delete':
            return react_1.default.createElement(ic_detail_delete_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'check-circle':
            return react_1.default.createElement(ic_check_in_circle_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'check-equal':
            return react_1.default.createElement(ic_check_in_equal_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'file-down':
            return react_1.default.createElement(ic_file_down_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'download':
            return react_1.default.createElement(ic_download_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'add_folder':
            return (react_1.default.createElement(ic_add_folder_svg_1.default, { style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'add_ring':
            return (react_1.default.createElement(ic_add_ring_svg_1.default, { style: style, dwidth: width, height: height, stroke: stroke, fill: fill }));
        case 'minus_ring':
            return (react_1.default.createElement(ic_minus_ring_svg_1.default, { style: style, dwidth: width, height: height, stroke: stroke, fill: fill }));
        case 'locked':
            return (react_1.default.createElement(ic_locked_svg_1.default, { style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'document':
            return (react_1.default.createElement(ic_document_svg_1.default, { style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'video':
            return (react_1.default.createElement(ic_video_svg_1.default, { style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'background':
            return (react_1.default.createElement(ic_background_svg_1.default, { style: style, width: width, height: height, stroke: stroke, fill: fill }));
        case 'plus':
            return react_1.default.createElement(ic_plus_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'home_on':
            return react_1.default.createElement(ic_home_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'home_off':
            return react_1.default.createElement(ic_home_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'liveRoom_on':
            return react_1.default.createElement(ic_live_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'liveRoom_off':
            return react_1.default.createElement(ic_live_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'logout_on':
            return react_1.default.createElement(LogoutOn_1.default, { width: width, height: height, fill: fill });
        case 'logout_off':
            return react_1.default.createElement(LogoutOff_1.default, { width: width, height: height, fill: fill });
        case 'learningManagement_on':
            return react_1.default.createElement(ic_management_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'learningManagement_off':
            return react_1.default.createElement(ic_management_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'myRoom_on':
            return react_1.default.createElement(ic_myclass_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'myRoom_off':
            return react_1.default.createElement(ic_myclass_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'learningSupportRoom_on':
            return react_1.default.createElement(ic_support_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'learningSupportRoom_off':
            return react_1.default.createElement(ic_support_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'notice_on':
            return react_1.default.createElement(NoticeOn_1.default, { width: width, height: height, fill: fill });
        case 'notice_off':
            return react_1.default.createElement(NoticeOff_1.default, { width: width, height: height, fill: fill });
        case 'menu_close':
            return (react_1.default.createElement(ic_menu_close_svg_1.default, { className: className, width: width, height: height, stroke: stroke, fill: fill }));
        case 'menu_open':
            return react_1.default.createElement(ic_menu_open_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'view':
            return react_1.default.createElement(ic_view_eye_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'no_pdf':
            return (react_1.default.createElement(ic_pdf_svg_1.default, { className: className, width: width, height: height, stroke: stroke, fill: fill }));
        case 'no_zip':
            return (react_1.default.createElement(ic_zip_svg_1.default, { className: className, width: width, height: height, stroke: stroke, fill: fill }));
        case 'question':
            return (react_1.default.createElement(ic_question_svg_1.default, { className: className, width: width, height: height, stroke: stroke, fill: fill }));
        case 'answer':
            return (react_1.default.createElement(ic_answer_svg_1.default, { className: className, width: width, height: height, stroke: stroke, fill: fill }));
        case 'page_off':
            return react_1.default.createElement(ic_page_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'page_on':
            return react_1.default.createElement(ic_page_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'cancel-mobile':
            return react_1.default.createElement(ic_cancel_mobile_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'no_image':
            return react_1.default.createElement(ic_no_image_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'delete_users':
            return react_1.default.createElement(ic_delete_users_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'add_users':
            return react_1.default.createElement(ic_add_users_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'circle_delete':
            return react_1.default.createElement(ic_delete_in_circle_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'circle_plus':
            return react_1.default.createElement(ic_plus_in_circle_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'dash':
            return react_1.default.createElement(ic_dash_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'file_upload':
            return react_1.default.createElement(ic_file_upload_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'fullScreen_off':
            return react_1.default.createElement(fullscreen_off_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'fullScreen_on':
            return react_1.default.createElement(fullscreen_on_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'arrow_in_circle_left':
            return react_1.default.createElement(ic_arrow_in_circle_left_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'arrow_in_circle_right':
            return react_1.default.createElement(ic_arrow_in_circle_right_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        case 'user':
            return react_1.default.createElement(ic_user_svg_1.default, { width: width, height: height, stroke: stroke, fill: fill });
        default:
            return null;
    }
});
exports.default = Icon;
